import ReactDatePickerModule from "react-datepicker";
import type { DatePickerProps } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// react-datepicker v7 has a double-wrapped default export due to CJS/ESM interop
const ReactDatePicker =
  "default" in ReactDatePickerModule
    ? (
        ReactDatePickerModule as unknown as {
          default: typeof ReactDatePickerModule;
        }
      ).default
    : ReactDatePickerModule;

export type { DatePickerProps };

export const DatePicker = ReactDatePicker;

export default DatePicker;
